export const OUTDATED_FLOW_VERSION = 'FlowUpdateError.OUTDATED_FLOW_VERSION';

// Enrollment failure
export const TOO_MANY_ASSOCIATION_FILTERS = 'ILS.TOO_MANY_ASSOCIATION_FILTERS_IN_CREATE_BATCH';